import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "@/lib/api";
import Seo from "@/components/Seo";
import { Eyebrow } from "@/components/Reveal";

export default function Legal() {
  const { slug } = useParams();
  const [doc, setDoc] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    setDoc(null);
    setError(false);
    api.get(`/legal/${slug}`).then((r) => setDoc(r.data)).catch(() => setError(true));
  }, [slug]);

  return (
    <div className="pt-24 sm:pt-28 pb-24" data-testid="legal-page">
      <div className="max-w-3xl mx-auto px-5 sm:px-8">
        {error && <h1 className="font-display text-2xl font-bold">Document not found</h1>}
        {!doc && !error && <p className="text-slate-500">Loading…</p>}
        {doc && (
          <>
            <Seo title={doc.title} path={`/legal/${slug}`} />
            <Eyebrow>LEGAL</Eyebrow>
            <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tight">{doc.title}</h1>
            <div className="mt-8 space-y-5">
              {doc.body.split("\n\n").map((para, i) => (
                <p key={i} className="text-slate-400 leading-relaxed">{para}</p>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
